import { render, staticRenderFns } from "./ConsumersList.vue?vue&type=template&id=440a4c31&"
import script from "./ConsumersList.vue?vue&type=script&lang=js&"
export * from "./ConsumersList.vue?vue&type=script&lang=js&"
import style0 from "./ConsumersList.vue?vue&type=style&index=0&id=440a4c31&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440a4c31')) {
      api.createRecord('440a4c31', component.options)
    } else {
      api.reload('440a4c31', component.options)
    }
    module.hot.accept("./ConsumersList.vue?vue&type=template&id=440a4c31&", function () {
      api.rerender('440a4c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConsumersList.vue"
export default component.exports